import $ from 'jquery';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

Array.from(document.querySelectorAll('.js-testimonials')).forEach(
  (testimonials) => {
    const options = {
      arrowShape: `M0 50c0 27.613 22.387 50 50 50s50-22.387 50-50S77.613 0 50 0 0 22.388 0 50zm60.828-23.303a5.96 5.96 0 010 8.434L45.825 49.963l15.003 14.831a5.96 5.96 0 010 8.434c-2.356 2.319-6.166 2.331-8.522 0L33.069 54.172c-2.331-2.319-2.331-6.103 0-8.434l19.237-19.044a6.07 6.07 0 018.522.003z`,
      contain: true,
      draggable: true,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
    };

    // Clone children until there's at least 10 - ensures that the width of the
    // window is full to avoid issues with wrapAround.
    const $testimonials = $(testimonials);
    while ($testimonials.children().length < 30) {
      const cloneChildren = $testimonials.children().clone();
      $testimonials.append(cloneChildren);
    }

    const flickity = new Flickity(testimonials, options);
  }
);
